export const TICKET_STATUS_DESCRIPTIONS = {
  OPEN: "The issue has been identified and is ready to be addressed.",
  TODO: "The issue requires further investigation or action before it can be resolved.",
  IN_PROGRESS: "Work on resolving the issue is currently underway.",
  RESOLVED:
    "The issue has been successfully addressed and no further actions are required.",
};
